import React, { ReactElement, useState } from 'react';
import { LoaderButton } from 'idsk-react-components';
import routes from '../../../../routing/routes';
import { downloadExportedFile } from '../../../../client/exportClient';
import { useSecurityContext } from '../../../../context/SecurityContext';
import iconDownload from '../../../../../assets/images/icon-download-blue.svg';
import Uuid from '../../../../model/Uuid';
import StadiumMaterialuEnum from '../../../../model/currentuser/StadiumMaterialuEnum';
import DownloadFromStadiumEnum from '../../../../model/downloadFromStadiumEnum';
import { useErrorMessageContext } from '../../../../context/ErrorMessageContext';
import Secured from '../../../../module/Secured';
import { useUserContext } from '../../../../context/UserContext';
import { isAdmin, isAktualnyPredkladatel } from '../../../../function/permissions';

interface Props {
  uuid: Uuid;
  actualStadium: StadiumMaterialuEnum;
}

const VlastnyMaterialButton = ({ uuid, actualStadium }: Props): ReactElement => {
  const [disabled, setDisabled] = useState<boolean>(false);
  const { accessToken, organizationId } = useSecurityContext();
  const { displayError } = useErrorMessageContext();
  const { pouzivatel, legislationProcess } = useUserContext();

  const handleClick = (): void => {
    if (StadiumMaterialuEnum.PROCES_UKONCENY === actualStadium
      || StadiumMaterialuEnum.VYHLASENE_V_ZBIERKE === actualStadium) {
      downloadExportedFile(
        routes.export.vlastnyMaterial.withParams(uuid, 'VlastnyMaterial'),
        'K aktuálnemu štádiu materiálu nie je pridaný žiadny dokument typu "Vlastný materiál".',
        setDisabled,
        undefined,
        accessToken,
        organizationId,
        DownloadFromStadiumEnum.PREVIOUS,
      ).then(errorMessage => {
        if (errorMessage) {
          displayError(errorMessage);
        }
      });
    } else {
      downloadExportedFile(
        routes.export.vlastnyMaterial.withParams(uuid, 'VlastnyMaterial'),
        'K aktuálnemu štádiu materiálu nie je pridaný žiadny dokument typu "Vlastný materiál".',
        setDisabled,
        undefined,
        accessToken,
        organizationId,
        DownloadFromStadiumEnum.CURRENT,
      ).then(errorMessage => {
        if (errorMessage) {
          displayError(errorMessage);
        }
      });
    }
  };

  return (
    <Secured
      additionalCheck={(StadiumMaterialuEnum.PRIPRAVA_MATERIALU !== actualStadium)
        || (isAktualnyPredkladatel(pouzivatel, legislationProcess) || isAdmin(pouzivatel))}
    >
      <LoaderButton
        customIconBefore={iconDownload}
        loading={disabled}
        size="small"
        buttonStyle="link"
        disabled={disabled}
        onClick={handleClick}
      >
        Vlastný materiál
      </LoaderButton>
    </Secured>
  );
};

export default VlastnyMaterialButton;
